import { Analytics } from '@workivate/tho-web-shared';

const instance = Analytics.AnalyticsEngine({
  appName: 'Hermes',
  measurementId: window.WAM.ENV.analyticsMeasurementId || '',
  debug: !IS_PRODUCTION,
  gtag: typeof window !== 'undefined' ? window.gtag : undefined,
});

export default instance;
